import CertificatesTeacherForm from './CertificatesTeacherForm';

export default CertificatesTeacherForm;
